import React from 'react';

import ContextMenu from 'flow/components/ContextMenu';
import SupervisorAgentContextMenu from 'flow/components/context-menus/SupervisorAgentContextMenu';
import useAppContext from 'flow/hooks/useAppContext';
import { useAppSelector } from 'flow/hooks/useRedux';
import { selectContactName } from 'flow/selectors/ExtensionSelectors';
import { ExtensionKey } from 'flow/types/EntityKeys';
import { getMoreOptionsLabel } from 'flow/utils/a11y-utils';

interface Props {
    agentKey: ExtensionKey;
    setActive: (value: boolean) => void;
}

// Own component so the agent's name and the translation subscription stay off
// the row, which re-renders on every profile and status change.
const SupervisorAgentRowMenu = ({ agentKey, setActive }: Props) => {
    const { i18next } = useAppContext();
    const agentName = useAppSelector((state) =>
        selectContactName(state, agentKey),
    );

    return (
        <ContextMenu
            triggerLabel={getMoreOptionsLabel(i18next, agentName)}
            setActive={setActive}
            preventOverflow={true}
            className="bg-gray-200"
        >
            <SupervisorAgentContextMenu extensionKey={agentKey} />
        </ContextMenu>
    );
};

export default SupervisorAgentRowMenu;
